<template>
  <div id="infoPage">
    信息维护
  </div>
</template>
<script>
export default {
  name: 'infoPage',
  data() {
    return {

    };
  }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/pages/infoManage/infoManage.vue